import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabGuardDirective } from './lab-guard.directive';
import { ChangeTrackerService } from './change-tracker/change-tracker.service';
import { LabGuard } from './lab-guard.service';


@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    LabGuardDirective
  ],
  declarations: [
    LabGuardDirective
  ],
  providers: [
    ChangeTrackerService,
    LabGuard
  ]
})
export class GuardsModule { }



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/shared/guards/guards.module.ts